/**
 * CCC app deployment shim for @crm/ComercialManagement.
 * Dev: empty base = same-origin; Vite sends /api/ccc/* → :5001, other /api/* → :5000.
 */
import {
  isCccBrowserHost,
  joinApiUrl,
  readViteEnv,
  resolveMainApiBase,
  stripTrailingSlash,
} from '../config/env';

function ensureHttpsResourceUrl(url: string | null | undefined): string | undefined {
  if (!url || typeof url !== 'string' || url.startsWith('data:image/')) return url || undefined;
  if (url.startsWith('http://') && (url.includes('crm.wondertrade.pt') || url.includes('51.38.181.110'))) {
    return url.replace(/^http:\/\//i, 'https://');
  }
  return url;
}

const isDev = Boolean(import.meta.env?.DEV);
const isBrowser = typeof window !== 'undefined';

const prodBackend = 'https://crm.wondertrade.pt';

export const DEPLOYMENT_CONFIG = {
  BACKEND_URLS: {
    LOCAL: '',
    PRODUCTION: prodBackend,
  },
  FRONTEND_URLS: {
    LOCAL: 'http://localhost:3000',
    PRODUCTION: prodBackend,
    CUSTOM_DOMAIN: prodBackend,
  },
  MEO_PORTAL_URL: 'https://portal.meo.pt',
  isDevelopment: isDev,
  isProduction: !isDev,
  getBackendUrl: (): string => {
    const configured = stripTrailingSlash(readViteEnv('VITE_MAIN_API_URL'));
    if (configured) return configured;
    if (isCccBrowserHost()) return '';
    if (isDev) return '';
    return prodBackend;
  },
  getResourceUrl: (pathOrUrl: string | null | undefined): string | undefined => {
    if (!pathOrUrl || typeof pathOrUrl !== 'string') return undefined;
    if (pathOrUrl.startsWith('data:image/')) return pathOrUrl;
    if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
      return ensureHttpsResourceUrl(pathOrUrl) || pathOrUrl;
    }
    if (isBrowser && isCccBrowserHost()) {
      return joinApiUrl(window.location.origin, pathOrUrl);
    }
    const base = isDev ? 'http://127.0.0.1:5000' : prodBackend;
    return joinApiUrl(base, pathOrUrl);
  },
  getFrontendUrl: () =>
    isDev ? 'http://localhost:3000' : prodBackend,
};

export default DEPLOYMENT_CONFIG;

// Re-export for modules that import deployment shim only
export { resolveMainApiBase, joinApiUrl };
